// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"53796a3b","239":"e199c0a8","557":"e70a58f5","667":"bbf30029","762":"44b2c467"}[chunkId] + ".chunk.js";
};